import * as actionTypes from "./actionTypes";

const initialState = {
  contactUsList: { contacts: [], error: null, loading: false }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONTACT_US:
      return {
        ...state,
        contactUsList: {
          ...state.contactUsList,
          error: null,
          loading: true
        }
      };

    case actionTypes.CONTACT_US_SUCCESS: {
      return {
        ...state,
        contactUsList: {
          contacts: action.payload.contacts,
          error: null,
          loading: false
        }
      };
    }

    case actionTypes.CONTACT_US_FAILURE:
      return {
        ...state,
        contactUsList: {
          sells: [],
          error: action.payload.error,
          loading: false
        }
      };

    case actionTypes.RESET_CONTACT_US:
      return { ...state, contactUsList: initialState.contactUsList };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/contactUs/reducer.js